import { Stack, Card, TextInput, Text, Divider, Group } from "@mantine/core";
import { IconCircleCheck, IconMail } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { searchClientsByEmail } from "../Protocol";

export let EmailName: any = "";
export interface UserLawFirm {
  law_firm_name: string;
  street_address_1: string;
  street_address_2: string;
  street_address: string;
  city: string;
  state: string;
  zip: string;
  email: string;
  phone_number: string;
}
export const law_firm_of_user: UserLawFirm = {
  law_firm_name: "",
  street_address_1: "",
  street_address_2: "",
  street_address: "",
  city: "",
  state: "",
  zip: "",
  email: "",
  phone_number: "",
};

export const ClientEmailSearch = ({ isEmailChecked }: { isEmailChecked: (checked: boolean) => void }) => {
  const [emailError, setEmailError] = useState(false);
  const [emailValid, setEmailValid] = useState(false);
  const [email, setEmail] = useState<null | string>(null);
  const [zip, setZip] = useState("");
  const [zipError, setZipError] = useState<null | string>(null);
  

  const checkEmail = () => { 
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setEmailError(false);
      setEmailValid(false);
      // searching_email = false;
      return;
    }
    
    // searching_email = true;
    searchClientsByEmail(email.trim()).then((clients) => {
      law_firm_of_user.email = email; // Copy email for manual entry

      if (clients.length > 0) {
        setEmailError(false);
        setEmailValid(true);
      }
      else{
        setEmailError(true);
        setEmailValid(false); 
        // searching_email = false;
        return;
      }
  
      // Object.entries(clients[0] as UserLawFirm).forEach(([key, value]) => {
      //   law_firm_of_user[key as keyof UserLawFirm] = value;
      //   console.log(key, value)
      // });
      setEmailError(false);
      setEmailValid(true); 
    }).finally(() => {
      isEmailChecked(true);
    });
  };

  useEffect(() => {
    isEmailChecked(false);
    EmailName = email;
    if (!email || email.trim() === "") {
      setEmailError(false);
      setEmailValid(false); 
      return;
    }
  
    const debounceTimeout = setTimeout(() => {
      checkEmail();
    }, 500);
  
    return () => {
      clearTimeout(debounceTimeout); 
    };
  }, [email]);

  return (
    <Stack>
      {!emailError && (
        <Card>
          <Text>Please enter your email</Text>
          <Divider />

          <TextInput
            required
            leftSection={<IconMail />}
            value={email || ""}
            onChange={(e) => {
              setEmail(e.currentTarget.value);
            }}
            autoComplete="emailAutoComplete" 
          />

          {emailValid && (
            <Group>
              <IconCircleCheck color="green" />
              <Text fz="xs">We have your information in our system.</Text>
            </Group>
          )}
          <Divider />
        </Card>
      )}

      {emailError && (
        <Card>
          <Text>We couldn't find this email in our system.</Text>
          <Text>Please fill out your information instead</Text>
          <TextInput
            required
            label="Email Address"
            leftSection={<IconMail />}
            value={email || ""}
            onChange={(e) => {
              setEmail(e.currentTarget.value);
            }}
            autoComplete="emailAutoComplete2" 
          />
          <TextInput
            onChange={(e) => {
              law_firm_of_user.law_firm_name = e.currentTarget.value;
            }}
            required
            label="Your Name or the Name of your law firm"
            autoComplete="client_law_firm_name"
          />
          <TextInput
            onChange={(e) => {
              law_firm_of_user.street_address_1 = e.currentTarget.value;
              law_firm_of_user.street_address =
                law_firm_of_user.street_address_1 +
                "," +
                law_firm_of_user.street_address_2;
            }}
            required
            label="Street address line 1"
            autoComplete="client_street_address_1"
          />
          <TextInput
            onChange={(e) => {
              law_firm_of_user.street_address_2 = e.currentTarget.value;
              law_firm_of_user.street_address =
                law_firm_of_user.street_address_1 +
                "," +
                law_firm_of_user.street_address_2;
            }}
            label="Street address line 2"
            autoComplete="client_street_address_2"
          />
          <TextInput
            onChange={(e) => {
              law_firm_of_user.city = e.currentTarget.value;
            }}
            required
            label="City"
            autoComplete="client_city"
          />
          <TextInput
            onChange={(e) => {
              law_firm_of_user.state = e.currentTarget.value;
            }}
            required
            maxLength={2}
            label="State (abbreviated)"
            autoComplete="client_state"
          />
          <TextInput
            onChange={(e) => {
              const normalizedZip = e.currentTarget.value.replace(/\D/g, "").slice(0, 5);
              setZip(normalizedZip);
              law_firm_of_user.zip = normalizedZip;
              setZipError(normalizedZip.length === 0 || normalizedZip.length === 5 ? null : "ZIP must be exactly 5 digits");
            }}
            value={zip}
            required
            maxLength={5}
            inputMode="numeric"
            pattern="[0-9]{5}"
            label="Zip Code"
            autoComplete="client_zip"
            error={zipError}
          />
          <TextInput
            onChange={(e) => {
              law_firm_of_user.phone_number = e.currentTarget.value;
            }}
            required
            label="Phone Number"
            autoComplete="client_phone_number"
          />
        </Card>
      )}
    </Stack>
  );
};
